import { render, staticRenderFns } from "./AchievementOverview.vue?vue&type=template&id=3a40fd32&scoped=true&"
import script from "./AchievementOverview.vue?vue&type=script&lang=ts&"
export * from "./AchievementOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AchievementOverview.vue?vue&type=style&index=0&id=3a40fd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40fd32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDialog,VIcon,VSelect})
